import DateService from '../../../../../services/dateService';
import React from 'react';
import getIcons from '../../../functions/getIcons/getIcons';

function BodyItem(props) {
  return (
    <div key={props.keyValue} className="my-account-main-tabs-body-my-transactions  font9">
      <div className="kupos-card transactions-body-item my-movements-heading ">
        <div className="text-center transactions-first-child">
          <span className="bold-text light-grey-text font12">
            {DateService.getDateFromDate(props.val.created_date, 'yyyy-mm-dd')}
          </span>{' '}
          <br />
          <span className="light-grey-text">
            {DateService.getMonthNameFromDate(props.val.created_date, 'yyyy-mm-dd', 'full')}
          </span>
        </div>

        <div className="vl"></div>
        <div className="flex-row transaction-status">
          <div>
            {props.val.type == 'pay_amount' && (
              <span className="bold-text font12 light-grey-text">
                {props.t('RESULTS_PAGE.PENDIENTE')}
              </span>
            )}
            {props.val.type == 'debit' && (
              <span className="bold-text font12 light-grey-text">
                {props.t('RESULTS_PAGE.DEBIT')}
              </span>
            )}
            {props.val.type == 'credit' && (
              <span className="bold-text font12 light-grey-text">
                {props.t('RESULTS_PAGE.CREDIT')}
              </span>
            )}
            {props.val.type == 'in_process' && (
              <span className="bold-text font12 light-grey-text">En proceso</span>
            )}
            {props.val.type == 'failed' && (
              <span className="bold-text font12 light-grey-text">Recarga fallida</span>
            )}

            <br />
            <span className=" light-grey-text">
              {props.t(
                props.getLabelName(props.val.category_info && props.val.category_info.label),
              )}
            </span>
          </div>

          <div
            className="see-more   less-bold-text"
            onClick={() => props.onSeeMoreClicked(props.keyValue)}
          >
            <span
              style={{
                color:
                  props.operator &&
                  props.operator.color_codes &&
                  props.operator.color_codes.account_text_color
                    ? props.operator.color_codes.account_text_color
                    : '',
              }}
            >
              {props.t('PROFILE.VIEW_MORE')}
            </span>
            <span className="flex-right my-movements-subitem">
              {props.operator ? (
                <img src={getIcons('downArrow', props.operator)} alt="" style={{ height: '1vw' }} />
              ) : (
                <img src="/static/images/icons/home/icon_arrow_down.png" alt="" />
              )}
            </span>
          </div>
        </div>

        <div className="vl"></div>

        <div>
          {props.val.type == 'debit' ? (
            <div>
              <span className="bold-text font12 red-text">
                - $
                {parseInt(
                  props.val.amount.split(' ')[1]
                    ? props.val.amount.split(' ')[1]
                    : props.val.amount,
                )}
              </span>{' '}
              <br />
            </div>
          ) : (
            <div className="">
              <span className="bold-text font12 green-text">
                + $
                {parseInt(
                  props.val.amount.split(' ')[1]
                    ? props.val.amount.split(' ')[1]
                    : props.val.amount,
                )}
              </span>{' '}
              <br />
            </div>
          )}
        </div>
      </div>

      <div
        className={
          'sub-body-my-trips font10 ' + (props.keyValue == props.selectedIndex ? 'show' : 'hide')
        }
      >
        <span className="sub-body-my-trips-title font10 primary-text-color bold-text">
          {props.t('PROFILE.TRANSACTION_DETAILS')}
        </span>{' '}
        <br />
        <div className="sub-body-sub-item">
          <div>
            <div>
              <span className="bold-text font10 light-grey-text">
                {props.t('PROFILE.CATEGORY')}
              </span>{' '}
              <br />
              <span className="font10 light-grey-text">
                {props.t(props.getLabelName(props.val.category_info.label))}
              </span>
            </div>
          </div>

          <div className="text-right">
            <div>
              <span className="bold-text font10 light-grey-text">
                {props.t('PROFILE.TRANSACTION_NUMBER')}
              </span>{' '}
              <br />
              <span className="font10 light-grey-text">{props.val.category_info.txn_code}</span>
            </div>
          </div>
        </div>
        <hr className="horizontal-line" />
        <div>
          <span className="bold-text font10 light-grey-text">
            {props.t('PROFILE.TRANSACTION_DETAILS')}
          </span>{' '}
          <br />
          <span className="font10 light-grey-text">{props.getTranslations(props.val.reasons)}</span>
        </div>
        <hr className="horizontal-line" />
        <div className="sub-body-sub-item">
          <div>
            <div>
              <span className="bold-text font10 light-grey-text">
                {props.t('PROFILE.TRANSACTION_DATE')}
              </span>{' '}
              <br />
              <span className="font10 light-grey-text">
                {' '}
                {DateService.changeDateFormat(props.val.created_date, 'yyyy-mm-dd', 'dd/mm/yyyy')}
              </span>
            </div>
          </div>

          <div className="text-right">
            <div>
              <span className="bold-text font10 light-grey-text">
                {props.t('PROFILE.TRANSACTION_HOUR')}
              </span>{' '}
              <br />
              <span className="font10 light-grey-text">{props.val.created_time}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BodyItem;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/MainTabsBodyMyTransactions/components/BodyItem.js